export class JobsOffer {
  id: string;
  title: string;
  contracttype_id: number;
  jobcategory_id: number;
  educationlevel_id: number;
  venue_id: string;
  jobtype_id: number;
  country: string;
  description: string;
  request: string;
  quantity: number;
  languages: any;
  requirements: any;
  report: any;
  users_selected: number;
  language: number;
  languageLevel: number;
  travel: boolean;
  impairment: number;
  expired_at: string;
  published_at: string;
  expired_at1: any;
  published_at1: any;
  englishLevel: boolean;
  car: number;
  experience: boolean;
  salary_range: number;
  salary_additional: string;
  salary_noshow: boolean;
  min_age: number;
  max_age: number;
  gender: number;
  move: boolean;
  salary: number;
  status: number;
  state: number;
  applications: number;
  views: number;
  private: boolean;
  premium: number;
  urgent: any;
  files: number;
  form: any;
  requisition_id: string;
  filelist: any;
  form_id: number;
  filelist_id: number;
  available_invitation: number;
  company: {
    logo: string;
    name: string;
  };
  educationlevel: {
    id: number;
    name: string;
  };
  venue: {
    id: string;
    name: string;
    address: string;
    country: {
      name: string;
    };
    countryAdmin1: {
      name: string;
    };
    countryAdmin2: {
      name: string;
    };
    lat: number;
    lng: number;
  };
  contracttype: {
    id: number;
    name: string;
  };
  jobcategory: {
    id: number;
    name: string;
  };
  jobtype: {
    id: number;
    name: string;
  };
}

export class Pagination {
  total: number;
  pages: number;
  pageCount: number;
}

export class PaginatedJobs {
  pagination: Pagination;
  applicants: JobsOffer[];
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/jobs-offer.ts